import './SectionHeader.scss'

import classNames from 'classnames'
import React, { HTMLProps } from 'react'

export interface SectionHeaderProps extends HTMLProps<HTMLDivElement> {
  className?: string
}

export const SECTION_HEADER_CLASS = 'section-header'

function SectionHeader(props: SectionHeaderProps) {
  const { className, ...otherProps } = props
  const mergedClassName = classNames(SECTION_HEADER_CLASS, className)

  return <div className={mergedClassName} {...otherProps} />
}

export interface TitleProps extends HTMLProps<HTMLHeadingElement> {
  className?: string
}

function Title(props: TitleProps) {
  const { className, ...otherProps } = props
  const mergedClassName = classNames('section-header__title', className)

  return <h3 className={mergedClassName} {...otherProps} />
}

export interface SubtitleProps extends HTMLProps<HTMLParagraphElement> {
  className?: string
}

function Subtitle(props: SubtitleProps) {
  const { className, ...otherProps } = props
  const mergedClassName = classNames('section-header__subtitle', className)

  return <p className={mergedClassName} {...otherProps} />
}

function Container(props: HTMLProps<HTMLDivElement>) {
  const { children, ...otherProps } = props

  return (
    <div className="section-header__container" {...otherProps}>
      {children}
    </div>
  )
}

export interface FiltersProps extends HTMLProps<HTMLDivElement> {
  className?: string
}

function Filters(props: FiltersProps) {
  const { children, className, ...otherProps } = props
  const mergedClassName = classNames('section-header__filters', className)

  return (
    <div className={mergedClassName} {...otherProps}>
      {children}
    </div>
  )
}

SectionHeader.Title = Title
SectionHeader.Subtitle = Subtitle
SectionHeader.Filters = Filters
SectionHeader.Container = Container
export default SectionHeader
